import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ArrayUtilityService {
  constructor() {}

  public chunkArray<T>(array: T[], chunkSize: number): T[][] {
    return array.reduce((resultArray, item, index) => {
      const chunkIndex = Math.floor(index / chunkSize);

      if (!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = []; // Initialize chunk array if it doesn't exist
      }

      resultArray[chunkIndex].push(item);

      return resultArray;
    }, []);
  }
}
